export default function parseFloat(value) {
    return !value || typeof value !== 'string' || Number.isNaN(+value)
        ? value
        : +value;
}
